import { IComplaint } from "../../constants/commonTypes";
import { LoadState } from "../../constants/enums";

export interface ISowMechanicComplaint {
  complaint_log_id: number;
  complaint_no: number;
  user_id: number;
  service_id: number;
  membership_code: string;
  assigned_mechanic_id: number;
  vehicle_type: string;
  vehicle_number: string;
  vehicle_make: string;
  vehicle_model: string;
  reg_contact_no: string;
  alternate_contact_no: string | null;
  service_city: string;
  service_state: string;
  selected_date: string;
  selected_slot: string | null;
  ongoing_issues: string | null;
  nodal_name: string | null;
  area: string | null;
  latitude: string | null;
  longitude: string | null;
  remark: string | null;
  service_status: string;
  service_status_reason: string | null;
  close_category: string;
  created_by_id: number;
  created_by_name: string;
  approved_by_id: number;
  approved_by_name: string;
  assigned_by_id: number;
  assigned_by_name: string;
  closed_by_id: number;
  closed_by_name: string;
  status: string;
  mechanic_reach_time: string;
  service_completed_time: string;
  comment: string;
  amount: number;
  additional_details: string | null;
  additional_amount: number | null;
  service_amount: number | null;
  service_type: string;
  insert_dt: string;
  user_name: string;
  created_dt: string;
}

export interface ISowMechanicDashboardAnalytics {
  totalComplaints: number;
  totalComplaintCancelled: number;
  totalComplaintsClosed: number;
  totalComplaintsOpen: number;
}

export interface ISowAnalyticsStatusCount {
  status: string;
  status_count: number;
}

export interface ISowAnalyticsApiResponse {
  totalRecords: ISowAnalyticsStatusCount[];
}

export interface ISowUserTransaction {
  sow_user_prospect_id: number;
  olddb_tempid: number | null;
  user_name: string;
  contact_no: string;
  email_id: string;
  state: string;
  membership_code: string;
  city: string;
  area: string;
  address: string;
  gstin: string;
  vehicle_no: string;
  make_name: string;
  model_name: string;
  fuel_type: string;
  package_name: string;
  package_id: number;
  package_price: number;
  package_period: number;
  package_services: number;
  comment: string;
  payment_date: string;
  payment_mode: string;
  promo_code: string;
  referral_code: string;
  status: "ACTIVE" | "PENDING";
  hof_id: number | null;
  partner_id: number;
  gst_percentage: number;
  gst_amount: number;
  insert_dt: string;
  branch_office: string;
  vehicle_number: string;
  maker_name: string;
  total_services: number;
  used_services: number;
  contact_number: string;
  remain_services: number;
  membership_start_date: string;
  membership_expiry_date: string;
  new?: boolean;
}

export interface IManageMembership {
  user_name: string;
  contact_number: string;
  email_id: string;
  vehicle_number: string;
  maker_name: string;
  model_name: string;
  state: string;
  city: string;
  area: string;
  address: string;
  status: string;
  total_services: number;
  used_services: number;
  remain_services: number;
  membership_start_date: string;
  membership_expiry_date: string;
  branch_office: string;
  membership_code: string;
}

export interface ISowDashbaord {
  sowUserTransactions: {
    transactionsByDate: {
      [key: string]:
        | {
            list: ISowUserTransaction[];
            count: number;
          }
        | undefined;
    };
  };
  complaints: {
    compaintsByDate: {
      [key: string]:
        | {
            list: IComplaint[];
            count: number;
          }
        | undefined;
    };
  };
  sowMechanicComplaint: {
    list: ISowMechanicComplaint[];
    amount: string;
    records: {
      currentRecords: number;
      totalPages: number;
      totalRecords: number;
    };
    totalRecords: number;
    error: string | null;
    loading: LoadState;
  };
  sowAnalytics: {
    data: ISowMechanicDashboardAnalytics;
    loading: LoadState;
    error: string | null;
  };
}

export const initialSowDashboard: ISowDashbaord = {
  sowUserTransactions: {
    transactionsByDate: {},
  },
  complaints: {
    compaintsByDate: {},
  },
  sowMechanicComplaint: {
    list: [],
    amount: "0",
    records: {
      currentRecords: 0,
      totalPages: 0,
      totalRecords: 0
    },
    totalRecords: 0,
    error: null,
    loading: LoadState.NotLoaded
  },
  sowAnalytics: {
    data: {
      totalComplaints: 0,
      totalComplaintCancelled: 0,
      totalComplaintsClosed: 0,
      totalComplaintsOpen: 0
    },
    loading: LoadState.NotLoaded,
    error: null
  }
};
